import React from "react";

interface IProps {
  timeout: number;
  withCountdown: boolean;
  renderCountdown: (secondsLeft: number) => React.ReactNode;
  children: React.ReactNode;
}

export const WaitRender: React.FC<IProps> = props => {
  const { timeout, withCountdown, renderCountdown, children } = props;

  // State
  const [secondsLeft, setSecondsLeft] = React.useState(
    Math.ceil(timeout / 1000),
  );
  const [isReady, setIsReady] = React.useState(false);

  // Lifecycle
  React.useEffect(() => {
    setIsReady(false);
    setSecondsLeft(Math.ceil(timeout / 1000));

    let countdownInterval: any;

    if (withCountdown) {
      countdownInterval = setInterval(() => {
        setSecondsLeft(prevValue => prevValue - 1);
      }, 1000);
    }

    setTimeout(() => {
      if (setIsReady) {
        clearInterval(countdownInterval);
        setIsReady(true);
      }
    }, timeout);

    return () => {
      clearInterval(countdownInterval);
    };
  }, [timeout, withCountdown]);

  // Render)
  if (!isReady) {
    if (withCountdown) {
      return <div>{renderCountdown(secondsLeft)}</div>;
    }

    return null;
  }

  return <div>{children}</div>;
};
